/* eslint-disable */
import React, { FC, useRef, useContext } from 'react'
import { Box, Heading, ResponsiveContext } from 'grommet'
import useComponentSize from '@rehooks/component-size'

const GoogleMapEmbed: FC = () => {
  const mapEmbedderRef = useRef(null)
  const containerSize = useComponentSize(mapEmbedderRef)
  const size = useContext(ResponsiveContext)

  return (
    <Box align="center">
      <Heading level={2} size="medium" margin={{ bottom: 'small' }}>
        Find us on Map
      </Heading>
      <Box ref={mapEmbedderRef} fill>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3429.4276787406125!2d79.06474646546242!3d30.734486092598566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39083ee051e628b1%3A0x167ce4efaf440f1e!2sKedarnath%2C%20Uttarakhand%20246445!5e0!3m2!1sen!2sin!4v1587298880900!5m2!1sen!2sin"
          width={containerSize.width}
          height={size === 'small' ? '360' : size === 'medium' ? '480' : '720'}
          frameBorder="0"
          style={{ border: 0 }}
          aria-hidden="false"
        ></iframe>
      </Box>
    </Box>
  )
}

export default GoogleMapEmbed

// width={size === 'small' ? '360' : size === 'medium' ? '560' : '1000'}
// height={size === 'small' ? '360' : size === 'medium' ? '480' : '720'}
